export default __webpack_public_path__ + "static/media/043-grandparents.50a4435f.png";